import { render, staticRenderFns } from "./Notaria.vue?vue&type=template&id=16695cac&scoped=true"
import script from "./Notaria.vue?vue&type=script&lang=js"
export * from "./Notaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16695cac",
  null
  
)

export default component.exports